export enum RequestMediaFailedReason {
  Blocked = 'Blocked',
  InUse = 'InUse',
  Other = 'Other',
}
